module.exports = __webpack_public_path__ + "media/images/client-25-7d6be4adb8349977ecc713f264e4390b.png";